<p class="text-right mb-2 flex flex-col">
  <span class="text-grey-dark-3 font-bold align-text-top">
    {{
      timeslot?.minPriceOffer?.price
        | displayPrice
          : timeslot?.minPriceOffer?.currency
          : timeslot?.maxPriceOffer?.price
    }}
  </span>
</p>
